export type Result<T, E = Error> = { ok: true; value: T } | { ok: false; error: E; status?: number };

export const Ok = <T>(value: T): Result<T, never> => ({ ok: true, value });

export const Err = <E>(error: E, status?: number): Result<never, E> => ({
  ok: false,
  error,
  status,
});

export function isOk<T, E>(result: Result<T, E>): result is { ok: true; value: T } {
  return result.ok === true;
}

export function isErr<T, E>(result: Result<T, E>): result is { ok: false; error: E } {
  return result.ok === false;
}
